import styled from 'styled-components';
import { Theme } from '@veneer/theme';

export const Background = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
  padding: calc(
      ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
        ${({ $veneerTheme }) => $veneerTheme.layout.size2}
    )
    calc(
      ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
        ${({ $veneerTheme }) => $veneerTheme.layout.size6}
    )
    0;
  @media (max-width: 1160px) {
    padding: calc(
        ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
          ${({ $veneerTheme }) => $veneerTheme.layout.size2}
      )
      calc(
        ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
          ${({ $veneerTheme }) => $veneerTheme.layout.size2}
      )
      0;
  }
  @media (max-width: 768px) {
    padding: ${({ $veneerTheme }) => $veneerTheme.layout.size8}
      ${({ $veneerTheme }) => $veneerTheme.layout.size4} 0;
  }
  @media (max-width: 575px) {
    & h1 {
      font-size: ${({ $veneerTheme }) => $veneerTheme.typography.size7};
    }
  }
`;

export const Message = styled.p<{ $veneerTheme: Theme }>`
  max-width: 100%;
  word-wrap: break-word;
`;
